import { Controller } from 'stimulus'

// A flyout is capped to the room left in the viewport, so a long menu scrolls.
const BOTTOM_GAP = 16
const MIN_HEIGHT = 200
const OPEN_DELAY = 450 // the flyout's .4s max-height transition

export default class extends Controller {
  connect() {
    this.onEnter = event => this._open(event.currentTarget)
    this._items().forEach(item => item.addEventListener('mouseenter', this.onEnter))
  }

  disconnect() {
    this._items().forEach(item => item.removeEventListener('mouseenter', this.onEnter))
    clearTimeout(this.revealTimer)
  }

  // Private methods

  _items() {
    return this.element.querySelectorAll('.sidebar__item')
  }

  _open(item) {
    const room = window.innerHeight - item.getBoundingClientRect().top - BOTTOM_GAP
    item.style.setProperty('--sidebar-flyout-max', `${Math.max(room, MIN_HEIGHT)}px`)

    clearTimeout(this.revealTimer)
    this.revealTimer = setTimeout(() => this._reveal(item), OPEN_DELAY)
  }

  _reveal(item) {
    const list    = item.querySelector('.sidebar__item__submenu')
    const current = list && list.querySelector('.sidebar__item__submenu--current')
    if (!current || current.offsetParent === null) return

    const listBox    = list.getBoundingClientRect()
    const currentBox = current.getBoundingClientRect()
    if (currentBox.top >= listBox.top && currentBox.bottom <= listBox.bottom) return

    list.scrollTop += currentBox.top - listBox.top - (list.clientHeight - currentBox.height) / 2
  }
}
